import { defineStore } from 'pinia'
import type { TIcons } from '@/components/icon/types'
import iconConfig from '@/components/icon/iconConfig.json'

export const useIconStore = defineStore('icon', () => {
  const iconAliases = new Map(Object.entries(iconConfig.aliases))

  function isValidIcon(value: string): value is TIcons {
    if (typeof value !== 'string') return false

    return iconAliases.has(value)
  }

  function getIconAlias(iconName: string): string | undefined {
    return iconAliases.get(iconName)
  }

  function safeIcon(value: string | number | undefined): TIcons | undefined {
    if (typeof value !== 'string') return undefined

    return isValidIcon(value) ? (value as TIcons) : undefined
  }

  function getIcon(name: string) {
    if (!isValidIcon(name)) {
      console.warn('Icon not found:', name)

      return
    }

    return getIconAlias(name)
  }

  return {
    getIcon,
    isValidIcon,
    getIconAlias,
    safeIcon
  }
})
